import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { ApiResponse } from '../shared/models';

export interface ApiErrorLogListItem {
    id: number;
    message?: string;
    level?: string;
    timeStamp: string;
    hasException: boolean;
    tenantDomain?: string;
    tenantUser?: string;
}

export interface ApiErrorLogEntry {
    id: number;
    message?: string;
    messageTemplate?: string;
    level?: string;
    timeStamp: string;
    exception?: string;
    properties?: string;
    logEvent?: string;
    tenantDomain?: string;
    tenantUser?: string;
    tenantUserId?: string;
}

export interface ApiErrorLogSearchRequest {
    fromDate?: string;
    toDate?: string;
    level?: string;
    searchText?: string;
    tenantDomain?: string;
    pageNumber: number;
    pageSize: number;
}

export interface ApiErrorLogSearchResult {
    items: ApiErrorLogListItem[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

@Injectable({ providedIn: 'root' })
export class ApiErrorLogService {
    private apiUrl: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiUrl = `${this.configService.get('apiBaseUrl')}/ApiErrorLog`;
    }

    getRecent(count: number = 15): Observable<ApiResponse<ApiErrorLogListItem[]>> {
        return this.http.get<ApiResponse<ApiErrorLogListItem[]>>(`${this.apiUrl}/GetRecent?count=${count}`).pipe(
            map(response => response)
        );
    }

    search(request: ApiErrorLogSearchRequest): Observable<ApiResponse<ApiErrorLogSearchResult>> {
        return this.http.post<ApiResponse<ApiErrorLogSearchResult>>(`${this.apiUrl}/Search`, request).pipe(
            map(response => response)
        );
    }

    getById(id: number): Observable<ApiResponse<ApiErrorLogEntry>> {
        return this.http.get<ApiResponse<ApiErrorLogEntry>>(`${this.apiUrl}/GetById/${id}`).pipe(
            map(response => response)
        );
    }
}
